import React from 'react';

const OptionList = ({ options }) => {
  const items = options.map(option => {
    const {
      id,
      smallImageUrl,
      description,
      displayName,
      primaryName,
      displayedMsrp
    } = option;
    const image = smallImageUrl ? (
      <img alt="" src={smallImageUrl} className="option-list-item__image" />
    ) : null;

    return (
      <li key={id} className="option-list-item">
        <span className="show-for-print">({id})</span>
        <div className="option-list-item__description-container">
          <span
            dangerouslySetInnerHTML={{
              __html: description || displayName || primaryName
            }}
          />
          <span className="price option-list-item__price">{displayedMsrp}</span>
        </div>
        {image}
      </li>
    );
  });
  return <ul className="option-list">{items}</ul>;
};

export default OptionList;
